"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ondc_1 = require("../axios/ondc");
const common_1 = require("../constants/common");
const fetchAllOndcVendors = async (lat_lng, lang = common_1.DEFAULT_LANG) => {
    try {
        const { vendor_details } = await (0, ondc_1.get)('/ondc/v1/providers', {
            lat_lng,
            lang,
        });
        return vendor_details || [];
    }
    catch {
        return [];
    }
};
exports.default = fetchAllOndcVendors;
